var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockContainer',{staticClass:"Step",attrs:{"type":"Read","progress":_vm.activity.progress}},[_c('ButtonWithCheckmark',{attrs:{"done":_vm.activity.progress === 1,"label":"Done"},on:{"click":function($event){return _vm.toggleRead()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }